import axios from 'axios';

const AUTH_TOKEN_KEY = 'forc.auth.token';

function getStoredAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

const http = axios.create({
  baseURL: '/api/v1',
  timeout: 15000,
});

http.interceptors.request.use((config) => {
  const token = getStoredAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default http;
